import { useEditPlayerLabelApi } from "../../../hooks";
import { usePlayContext } from "../../../pages/Play/play-context";

export interface UsePlayingSurfaceContextApiProps {
  isEditable: boolean;
}

export const usePlayingSurfaceContextApi = ({ isEditable }: UsePlayingSurfaceContextApiProps) => {
  const { frameStencilsApi } = usePlayContext();
  const { updateFrameStencils } = frameStencilsApi;

  const editPlayerLabelApi = useEditPlayerLabelApi({ updateFrameStencils });

  return { editPlayerLabelApi, isEditable };
};

export type PlayingSurfaceContextApi = ReturnType<typeof usePlayingSurfaceContextApi>;
